import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/layout/Footer";

export default function PolitiqueCookies() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white pt-20 text-black">
      <section className="px-6 pb-4 pt-10">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-semibold leading-tight">
            Politique de cookies
          </h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 16/04/2026</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="mx-auto max-w-3xl space-y-10 text-[15px] leading-7 text-gray-800">
          <p>
            La présente politique de cookies explique comment le site{" "}
            <span className="font-medium">savoinimaux.fr</span> utilise des
            cookies et autres traceurs lors de votre navigation.
          </p>

          <p>
            Lors de votre première visite, un bandeau vous permet d’accepter, de
            refuser ou de personnaliser l’usage des cookies non strictement
            nécessaires.
          </p>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              1. Qu’est-ce qu’un cookie ?
            </h2>
            <p>
              Un cookie est un petit fichier texte déposé sur votre terminal
              (ordinateur, tablette, smartphone) lors de la consultation d’un site
              internet. Il permet par exemple de mémoriser certaines préférences,
              d’assurer le fonctionnement du site ou de mesurer l’audience.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              2. Types de cookies utilisés
            </h2>
            <p>Le site Savoinimaux peut utiliser les catégories suivantes :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                <span className="font-medium">Cookies nécessaires :</span> ils sont
                indispensables au bon fonctionnement du site et à la mémorisation
                de votre choix de consentement ;
              </li>
              <li>
                <span className="font-medium">Cookies de mesure d’audience :</span>{" "}
                ils permettent de mieux comprendre la fréquentation du site et
                d’améliorer son contenu, uniquement avec votre accord lorsque cela
                est requis ;
              </li>
              <li>
                <span className="font-medium">Cookies liés à des contenus externes :</span>{" "}
                ils permettent l’affichage de contenus tiers intégrés au site,
                uniquement avec votre accord lorsque cela est requis.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              3. Cookies strictement nécessaires
            </h2>
            <p>
              Certains cookies sont nécessaires au fonctionnement technique du
              site. Ils permettent notamment :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>La navigation sur le site ;</li>
              <li>La sécurité du site ;</li>
              <li>La mémorisation de vos préférences de consentement.</li>
            </ul>
            <p className="mt-3">
              Ces cookies ne nécessitent pas de consentement préalable lorsqu’ils
              sont strictement nécessaires.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              4. Cookies soumis à consentement
            </h2>
            <p>
              Les cookies de mesure d’audience et les cookies liés à des services
              externes ne sont activés qu’après votre accord, lorsque la
              réglementation l’exige.
            </p>
            <p className="mt-3">
              Vous pouvez les accepter, les refuser ou personnaliser votre choix
              depuis le bandeau affiché lors de votre première visite.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              5. Gestion des préférences
            </h2>
            <p>
              Vous pouvez modifier votre choix à tout moment via le lien{" "}
              <span className="font-medium">« Gérer mes cookies »</span> présent en
              bas de page du site.
            </p>
            <p className="mt-3">
              Vous pouvez également paramétrer votre navigateur afin de bloquer ou
              supprimer certains cookies.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              6. Durée de conservation
            </h2>
            <p>
              Le choix exprimé via le bandeau cookies est conservé pendant une
              durée maximale de 6 mois.
            </p>
            <p className="mt-3">
              Les autres cookies, lorsqu’ils sont utilisés, sont conservés pour une
              durée proportionnée à leur finalité et conformément à la
              réglementation applicable.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              7. Finalités des cookies
            </h2>
            <p>Les cookies peuvent être utilisés pour :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Garantir le bon fonctionnement du site ;</li>
              <li>Mesurer la fréquentation et améliorer les contenus ;</li>
              <li>Autoriser l’affichage de certains contenus externes ;</li>
              <li>Mémoriser vos préférences de consentement.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              8. Données personnelles et cookies
            </h2>
            <p>
              Certains cookies peuvent impliquer un traitement de données
              personnelles. Pour en savoir plus sur la manière dont vos données
              personnelles sont traitées, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">
                Politique de confidentialité
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              9. Mise à jour de la politique de cookies
            </h2>
            <p>
              La présente politique de cookies peut être modifiée à tout moment
              afin de tenir compte des évolutions légales, réglementaires ou
              techniques.
            </p>
            <p className="mt-3">
              Les utilisateurs sont invités à la consulter régulièrement.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}